var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74967 18.9583C8.74967 16.5521 9.72676 14.3646 11.3163 12.775L9.24551 10.7041C7.14551 12.8187 5.83301 15.7354 5.83301 18.9583C5.83301 24.9083 10.2809 29.8083 16.0413 30.5229V27.5771C11.9143 26.8771 8.74967 23.2896 8.74967 18.9583ZM29.1663 18.9583C29.1663 12.5125 23.9455 7.29165 17.4997 7.29165C17.4122 7.29165 17.3247 7.30623 17.2372 7.30623L18.8268 5.71665L16.7705 3.64581L11.6663 8.74998L16.7705 13.8541L18.8268 11.7979L17.2518 10.2229C17.3393 10.2229 17.4268 10.2083 17.4997 10.2083C22.3268 10.2083 26.2497 14.1312 26.2497 18.9583C26.2497 23.2896 23.0851 26.8771 18.958 27.5771V30.5229C24.7184 29.8083 29.1663 24.9083 29.1663 18.9583Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.9cea2d263839ed3d6c4d1e394fa21336.svg";
export { ForwardRef as ReactComponent };